module.exports = __webpack_public_path__ + "b48640811789f6fd113fa3dce7b64cd0.fbx";